import type { FC } from "react";

interface Props {
  readonly value: string;
}

const Email: FC<Props> = ({ value }) => (
  <a href={`mailto:${value}`} target="_blank" onClick={(e) => e.stopPropagation()} rel="noreferrer">
    {value}
  </a>
);

export default Email;
